"use strict";
class Packages {
    static get isPackage() {
        const urlParams = new URLSearchParams(window.location.search);
        const packageId = urlParams.get('packageId');
        const optionId = urlParams.get('optionId');
        return !!packageId && !!optionId;
    }
    static updatePdpElements() {
        const hidePdpElements = () => {
            const headerComponent = document.getElementById('header-component');
            if (headerComponent) {
                headerComponent.style.display = 'none';
            }
            document.querySelectorAll('.footer').forEach((element) => {
                element.style.display = 'none';
            });
            const leavePageLink = document.getElementById('packages-leave-page');
            if (leavePageLink) {
                leavePageLink.style.display = 'block';
                leavePageLink.onclick = (e) => {
                    const urlParams = new URLSearchParams(window.location.search);
                    const packageId = urlParams.get('packageId');
                    const optionId = urlParams.get('optionId');
                    e.preventDefault();
                    window.location.href = `/a/package-builder/packages/${packageId}/styles/${optionId}`;
                };
            }
        };
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', hidePdpElements, { once: true });
        }
        else {
            hidePdpElements();
        }
        //  update breadcrumb area
        const breadcrumb = document.querySelector('[data-nav-style="breadcrumb"]');
        if (breadcrumb) {
            breadcrumb.innerHTML = '';
        }
    }
    static updatePdpWithPackageData(packageData) {
        document.getElementById('packages-name').textContent = packageData?.packageTitle || 'Package Product';
        //  update selection state if exist
        const urlParams = new URLSearchParams(window.location.search);
        const optionId = urlParams.get('optionId');
        if (!optionId)
            return;
        const optionData = packageData?.selectionState?.[optionId]?.shopifyVariants;
        if (!optionData)
            return;
        optionData.forEach((variant) => {
            const variantId = variant.shopifyVariantId.split('/').pop();
            const selector = `.quantity-input[data-variant-id="${variantId}"]`;
            const selectElement = document.querySelector(selector);
            if (selectElement) {
                selectElement.value = variant.quantity.toString();
                const color = selectElement.parentElement?.dataset.colorMatch;
                document.querySelector(`input[data-color-name="${color}"]`)?.click();
            }
            const qtyInput = document.querySelector('.qty-input');
            if (qtyInput) {
                qtyInput.value = variant.quantity.toString();
            }
            const colorOption = document.querySelector(`.color-option input[data-variant-id="${variantId}"]`);
            if (colorOption) {
                colorOption.click();
            }
        });
    }
    static get isEdit() {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.has('edit');
    }
    static getPackageData() {
        const urlParams = new URLSearchParams(window.location.search);
        const packageId = urlParams.get('packageId');
        var packageSelectionEndpoing = new URL('/a/package-builder/api/package/selection', window.location.origin);
        packageSelectionEndpoing.search = new URLSearchParams({
            userId: localStorage.getItem('packagebuilder_session_id') || '',
            packageItemNumber: packageId || ''
        }).toString();
        return fetch(packageSelectionEndpoing.toString()).then(async (response) => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            var responseData = await response.json();
            if (responseData.success) {
                this.Quantity = responseData.data?.quantity;
                return responseData.data;
            }
            else {
                throw new Error('Failed to fetch package data');
            }
        });
    }
    static addPackageSelection(payload) {
        try {
            fetch('/a/package-builder/api/package-style-selection', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            }).then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                window.location.href = `/a/package-builder/packages/${payload.packageItemNumber}`;
            });
        }
        catch (error) {
            console.error('Error adding package selection:', error);
        }
    }
}
Packages.Quantity = null;
